import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `ToggableWidget` renders toggable contents.
 * Use `toggle` to show/hide the widget, or `setVisibility` if you want to forward a state.
 *
 * @param {boolean} visible - Indicate whether to show the content by default.
 * @param {Renderable} content - Renderable to show/hide.
 * @param {string} [cssClass] - CSS class to add to the main div element
 */
export default class ToggableWidget extends Widget {
	constructor({ visible, content, cssClass = "" }) {
		super(...arguments);

		this._visible = visible;
		this._content = content || (() => {});
		this._cssClass = cssClass;
	}

	toggle() {
		this._visible = !this._visible;

		if (!this._mainDiv) {
			return Promise.resolve();
		}

		return new Promise((resolve) => {
			this._mainDiv.asJQuery().slideToggle(300, () => {
				// Avoid the hidden overflow set by slideToggle
				this._mainDiv.css("overflow", "visible");
				resolve();
			});
		});
	}

	setVisibility(state) {
		if (state === this._visible) {
			return;
		}

		this.toggle();
	}

	isVisible() {
		return this._visible;
	}

	hide() {
		return this.isVisible() ? this.toggle() : Promise.resolve();
	}

	show() {
		return this.isVisible() ? Promise.resolve() : this.toggle();
	}

	setContent(content) {
		this._content = content;

		this.update();
	}

	renderContentOn(html) {
		this._mainDiv = html.div(
			{ klass: ["toggle-widget", this._cssClass] },
			this._content,
		);

		if (!this._visible) {
			this._mainDiv.asJQuery().hide();
		}
	}
}
